export default __webpack_public_path__ + "maps-examples-live-data-thumbnail-960-a334295fa40a811190ce1a3a276acf6c.webp";